const isProd = window.location.hostname === 'app.8arm.io';

export const FLAGS = {
  ENABLE_PAYROLL_TOTAL_COST: true,
  ENABLE_PAYROLL_RUBRICA_FILTER: !isProd,
};
